import { Line } from 'vue-chartjs'
import * as d3 from "d3";
export default {
  extends: Line,
  data: () => ({
    labels: [],
    data: [],
    lug: [],
    mme: [],
    mmg: [],
    nrs: [],
    // gfm: [],
    // rve: [],
    // res: [],
    rok: [],
    // svp: [],
    spotifyse: [],
    fullLabels: [],
    fullLug: [],
    fullMme: [],
    fullMmg: [],
    fullNrs: [],
    fullRok: [],
    fullSpotifyse: []
  }),
  mounted () {
    this.logTest()
    this.loadData()
    // react to date range changes
    if (this.$store && this.$store.watch) {
      this.$store.watch(
        state => state.dateRange,
        () => {
          this.filterAndRender()
        }
      )
    }
  },
  methods: {
      loadData: function() {
        d3.csv('https://radio-kollen-public.s3-eu-west-1.amazonaws.com/percentage-bauer-collection.csv', (data) => {
            this.fullLug.push(parseInt(data['lug']));
            this.fullMme.push(parseInt(data['mme']));
            this.fullMmg.push(parseInt(data['mmg']));
            this.fullNrs.push(parseInt(data['nrs']));
            // this.gfm.push(parseInt(data['gfm']));
            // this.res.push(parseInt(data['res']));
            this.fullRok.push(parseInt(data['rok']));
            // this.svp.push(parseInt(data['svp']));
            this.fullSpotifyse.push(parseInt(data['spotifyse']));
            this.fullLabels.push(data['date']);
        }).then( () => {
            this.filterAndRender()
        }
        );
      },
      filterAndRender: function() {
        const start = this.$store && this.$store.state.dateRange.start ? this.$store.state.dateRange.start : null
        const end = this.$store && this.$store.state.dateRange.end ? this.$store.state.dateRange.end : null
        const labels = []
        const lug = []
        const mme = []
        const mmg = []
        const nrs = []
        const rok = []
        const spotifyse = []
        for (let i = 0; i < this.fullLabels.length; i++) {
          const date = this.fullLabels[i]
          if ((start === null || date >= start) && (end === null || date <= end)) {
            labels.push(date)
            lug.push(this.fullLug[i])
            mme.push(this.fullMme[i])
            mmg.push(this.fullMmg[i])
            nrs.push(this.fullNrs[i])
            rok.push(this.fullRok[i])
            spotifyse.push(this.fullSpotifyse[i])
          }
        }
        this.labels = labels
        this.lug = lug
        this.mme = mme
        this.mmg = mmg
        this.nrs = nrs
        this.rok = rok
        this.spotifyse = spotifyse
        this.renderChart({
                  labels: this.labels,
                  datasets: [
                    {
                      type: 'line',
                      label: 'Lugna Klassiker',
                      borderColor: '#41B8AE',
                      data: this.lug,
                      fill: false
                    },
                    {
                      type: 'line',
                      label: 'Mix Megapol',
                      borderColor: '#BE0F76',
                      data: this.mme,
                      fill: false
                    },
                    {
                      type: 'line',
                      label: 'Mix Megapol Göteborg',
                      borderColor: '#E51233',
                      data: this.mmg,
                      fill: false
                    },
                    {
                      type: 'line',
                      label: 'NRJ',
                      borderColor: '#C50914',
                      data: this.nrs,
                      fill: false

                    },
                    // {
                    //   type: 'line',
                    //   label: 'Gold FM',
                    //   borderColor: '#DDB74F',
                    //   data: this.gfm,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Radioactive',
                    //   borderColor: '#F3A57E',
                    //   data: this.rve,
                    //   fill: false
                    // },
                    // {
                    //   type: 'line',
                    //   label: 'Retro FM',
                    //   borderColor: '#000F2B',
                    //   data: this.res,
                    //   fill: false
                    // },
                    {
                      type: 'line',
                      label: 'Rockklassiker',
                      borderColor: '#F39100',
                      data: this.rok,
                      fill: false
                    },
                    // {
                    //   type: 'line',
                    //   label: 'Svensk Pop',
                    //   borderColor: '#005795',
                    //   data: this.svp,
                    //   fill: false
                    // },
                    {
                      type: 'line',
                      label: 'Spotify Sverige (Top 50)',
                      borderColor: 'rgb(30, 215, 96)',
                      data: this.spotifyse,
                      fill: false
                    }
                    /** 
                     * Mer P4:
                     * 28/41/167
                     * https://sverigesradio.se/diverse/appdata/isidor/files/3113/9463.pdf
                     * 
                    */
                  ]}, {
                    title: {
                      display: false,
                      text: ''
                    },
                    scales: {
                      yAxes: [{
                        stacked: false,
                        scaleLabel: {
                          display: true,
                          labelString: 'Andel musiker som är kvinnliga (%)'
                        },
                        ticks: {
                          beginAtZero: true,
                          suggestedMax: 50,
                        },
                      }],
                      xAxes: [ {
                        stacked: false,
                        categoryPercentage: 0.5,
                        barPercentage: 1
                      }]
                    },
                    legend: {
                      display: true
                    },
                    responsive: true,
                    maintainAspectRatio: false
                  }
                )
      },
      logTest: function() {
          //console.log("Hello!")
      }
  }
}